

import { defineComponent } from "vue";

import NavigationBarView from "Headers/NavigationBarView.vue";
import FooterView from "Common/Footer/FooterView.vue";
import BackButtonView from "Headers/BackButtonView.vue";

export default defineComponent({
  props: {
    hasFooter: {
      type: Boolean,
      default: true,
    },
    hasHeader: {
      type: Boolean,
      default: true,
    },
    hideNavigationItem: {
      type: Boolean,
      default: false,
    },
    hasBackButton: {
      type: Boolean,
      default: true,
    },
    headerCssClass: String,
    headerCssStyle: String,
    mainContentCssClass: String,
    mainContentCssStyle: String,
  },
  watch: {
    hasFooter: {
      immediate: true,
      handler(newVal, oldVal) {
        const bodyClass = document.body.classList;
        if (!newVal) {
          bodyClass.add("pb-0");
        } else {
          bodyClass.remove("pb-0");
        }
      },
    },
    hasHeader: {
      immediate: true,
      handler(newVal, oldVal) {
        const bodyClass = document.body.classList;
        if (!newVal) {
          bodyClass.add("pt-0");
        } else {
          bodyClass.remove("pt-0");
        }
      },
    },
  },
  components: {
    NavigationBarView,
    FooterView,
    BackButtonView,
  },
});
